import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section id="cta" className="py-14 md:py-32 bg-charcoal relative overflow-hidden" data-id="element-59" data-mp="3udf9v3lh1fkb">
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-60" data-mp="c7k5ny2p8nov">
        <FadeIn data-id="element-61" data-mp="84nswnzublsu">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-8 md:mb-12" data-id="element-62" data-mp="8449f2ujkpcp">
            Hay 2 opciones después de leer esto.
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-10 md:mb-16 text-left" data-id="element-63" data-mp="h6dl3w1jqoro">
          <FadeIn delay={0.15} className="bg-charcoal-dark border border-charcoal-light p-6 md:p-8 rounded-sm" data-id="element-64" data-mp="vui3t00ln0ag">
            <h3 className="text-lg font-heading font-bold text-offwhite-dim mb-4 uppercase tracking-wider" data-id="element-65" data-mp="qw6wox1ov3vx">
              Opción 1
            </h3>
            <p className="text-offwhite-dim/80" data-id="element-66" data-mp="zwmvvubefouz">
              Cerrás esto y decís <em data-id="element-67" data-mp="zua64uzega7d">"lo pienso"</em>. En tres semanas seguís en
              el mismo loop. La misma tensión. El tiempo sigue pasando.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="bg-charcoal-dark border border-sand/50 p-6 md:p-8 rounded-sm" data-id="element-68" data-mp="2h4j0kvrghop5">
            <h3 className="text-lg font-heading font-bold text-sand mb-4 uppercase tracking-wider" data-id="element-69" data-mp="2m572ich83py5">
              Opción 2
            </h3>
            <p className="text-offwhite" data-id="element-70" data-mp="2v4alzhkay7d6">
              Agendás la llamada gratuita ahora. 30 minutos para entender si
              esto es para vos. Sin compromiso. Si lo es, empezamos. Si no, te lo
              digo yo primero.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.45} className="space-y-6 md:space-y-8" data-id="element-71" data-mp="39s5diumkq5oo">
          <p className="text-xl text-offwhite-dim" data-id="element-72" data-mp="39uhtx3coo7zm">
            No te pido que cambies tu vida.
          </p>
          <p className="text-2xl md:text-3xl font-heading font-bold text-amber" data-id="element-73" data-mp="3epordtfd0gg3">
            Te pido 30 minutos para ver si podés.
          </p>

          <div className="pt-4" data-id="element-74" data-mp="1jnjx3tlid4mb">
            <Button href="https://wa.link/we351n" size="lg" withArrow className="shadow-2xl shadow-sand/20 w-full sm:w-auto" data-id="element-75" data-mp="1jola43m3416o">
              Agendar llamada gratuita
            </Button>
          </div>

          <p className="italic text-offwhite-dim pt-2" data-id="element-76" data-mp="1novqma7i69zs">
            Cuando volvés a vos, tu casa lo siente.
          </p>
        </FadeIn>
      </div>
    </section>;
}